import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Underline } from "../../widgets";

import "./Feedback.css";

const facultyblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/facultyblack.webp";
const collabooratorblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/collabooratorblack.webp";
const counsaltancyblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/counsaltancyblack.webp";
const parentsblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/parentsblack.webp";
const graduationblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/graduationblack.webp";
const studentblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/studentblack.webp";
const supplierblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/supplierblack.webp";
const employeeblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/employeeblack.webp";
const facilitiesblack = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Feedback/facilities_fb+(2).webp";

const Feedback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "ACCET-FEEDBACK";
  }, []);

  const handleNavigation = (path) => {
    if (/^https?:\/\//i.test(path)) {
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      navigate(path);
    }
  };

  return (
    <div className="feedback_whole">
      <div className="feedback_heading">
        <Underline heading="Feedback" />
      </div>

      <div className="feedback_whole_container">
        <div className="feedback_grid">

          <div className="student_feedback" onClick={() => handleNavigation("/feedback/student_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={studentblack} alt="student" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Student</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="alumini_feedback" onClick={() => handleNavigation("/feedback/alumini_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={graduationblack} alt="alumni" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Alumni</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="counsaltancy_feedback" onClick={() => handleNavigation("/feedback/consultancy_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={counsaltancyblack} alt="consultancy" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Consultancy</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="parents_feedback" onClick={() => handleNavigation("/feedback/parents_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={parentsblack} alt="parents" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Parents</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="supplier_feedback" onClick={() => handleNavigation("/feedback/supplier_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={supplierblack} alt="supplier" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Supplier</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="faculty_feedback" onClick={() => handleNavigation("/feedback/faculty_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={facultyblack} alt="faculty" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Faculty</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="employer_feedback" onClick={() => handleNavigation("/feedback/employer_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={employeeblack} alt="employer" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Employer</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

          <div className="collaborator_feedback" onClick={() => handleNavigation("/feedback/collaborator_fb")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={collabooratorblack} alt="collaborator" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Collaborator</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>
          <div className="counsaltancy_feedback" onClick={() => handleNavigation("https://docs.google.com/forms/d/e/1FAIpQLSe_WwswESoPhfLD7Xg_Xo-Q78AeD_DVC-SiUgSRKUGLhcDQxA/viewform?usp=sf_link")}>
            <div className="feedback_top_image">
              <img className="feedback_image" src={facilitiesblack} alt="Facilities" />
            </div>
            <div className="feedback_content">
              <div className="feedback_description">Facilities</div>
              <div className="feedback_description1">Feedback</div>
              <div className="feedback-card-arrow">➔</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Feedback;
